// src/pages/tpv/TpvPage.jsx

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { get } from '../../helpers/apiHelper';
import Swal from 'sweetalert2';
import TpvManager from '../../components/tpv/TpvManager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faStore, faBuilding } from '@fortawesome/free-solid-svg-icons';

const TpvPage = () => {
    const { tiendaId } = useParams();
    const [tienda, setTienda] = useState(null);
    const [marca, setMarca] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (tiendaId) {
            fetchTiendaData();
        }
    }, [tiendaId]);

    const fetchTiendaData = async () => {
        try {
            setLoading(true);

            // Obtener datos de la tienda
            const tiendaResponse = await get(`tiendas/${tiendaId}`);
            setTienda(tiendaResponse);

            // Obtener datos de la marca
            if (tiendaResponse.marca) {
                const marcaResponse = await get(`marcas/${tiendaResponse.marca}`);
                setMarca(marcaResponse);
            }
        } catch (error) {
            console.error('Error fetching tienda data:', error);
            Swal.fire({
                title: 'Error',
                text: 'No se pudieron cargar los datos de la tienda',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            });
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        window.history.back();
    };

    if (loading) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                    <p className="text-gray-600">Cargando datos de la tienda...</p>
                </div>
            </div>
        );
    }

    if (!tienda) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center">
                    <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <FontAwesomeIcon icon={faStore} className="text-red-600 text-2xl" />
                    </div>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">Tienda no encontrada</h2>
                    <p className="text-gray-600 mb-4">La tienda que buscas no existe o no tienes permisos para acceder</p>
                    <button
                        onClick={handleBack}
                        className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
                    >
                        Volver
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header */}
            <div className="bg-white shadow-sm border-b">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        <div className="flex items-center gap-4">
                            <button
                                onClick={handleBack}
                                className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                            >
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </button>

                            <div className="flex items-center gap-3">
                                <div className="p-2 bg-blue-100 rounded-lg">
                                    <FontAwesomeIcon icon={faStore} className="text-blue-600" />
                                </div>
                                <div>
                                    <h1 className="text-lg font-semibold text-gray-800">{tienda.nombre}</h1>
                                    {marca && (
                                        <div className="flex items-center gap-2 text-sm text-gray-600">
                                            <FontAwesomeIcon icon={faBuilding} className="text-xs" />
                                            <span>{marca.nombre}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="flex items-center gap-2">
                            <span className="text-sm text-gray-500">
                                {tienda.via} {tienda.calle} {tienda.numero}, {tienda.poblacion}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <TpvManager
                    tiendaId={tiendaId}
                    marcaId={tienda.marca}
                />
            </div>
        </div>
    );
};

export default TpvPage;



